import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  MenuItem,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  LinearProgress
} from '@mui/material';
import {
  Upload,
  GetApp
} from '@mui/icons-material';

const DocumentManagementDialog = ({
  open,
  onClose,
  documentContext,
  documentList,
  documentForm,
  setDocumentForm,
  documentUploading,
  documentUploadProgress,
  onUpload,
  onDownload
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        {documentContext.entityType === 'ASSEMBLY'
          ? 'Assembly Documents'
          : documentContext.entityType === 'COMPONENT'
          ? 'Component Documents'
          : 'Documents'}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Existing Documents
          </Typography>
          {documentList.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No documents uploaded yet.
            </Typography>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Type</TableCell>
                  <TableCell>Sub-Type</TableCell>
                  <TableCell>Version</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Uploaded By</TableCell>
                  <TableCell>Uploaded At</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {documentList.map((doc) => (
                  <TableRow key={doc._id}>
                    <TableCell>{doc.documentType}</TableCell>
                    <TableCell>{doc.documentSubType || '-'}</TableCell>
                    <TableCell>{doc.version}</TableCell>
                    <TableCell>{doc.description || '-'}</TableCell>
                    <TableCell>
                      {doc.uploadedBy
                        ? `${doc.uploadedBy.firstName || ''} ${doc.uploadedBy.lastName || ''}`.trim() ||
                          doc.uploadedBy.email
                        : '-'}
                    </TableCell>
                    <TableCell>
                      {doc.uploadedAt ? new Date(doc.uploadedAt).toLocaleString() : '-'}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => onDownload(doc._id, doc.originalFileName)}
                        title="Download Document"
                      >
                        <GetApp />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Upload New Document
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                select
                label="Document Type"
                value={documentForm.documentType}
                onChange={(e) =>
                  setDocumentForm({ ...documentForm, documentType: e.target.value })
                }
              >
                <MenuItem value="MANUAL">Manual</MenuItem>
                <MenuItem value="SPECIFICATIONS">Specifications</MenuItem>
                <MenuItem value="WARRANTY">Warranty</MenuItem>
                <MenuItem value="SERVICE_HISTORY">Service History</MenuItem>
                <MenuItem value="CERTIFICATE_OF_REGISTRATION">Certificate of Registration</MenuItem>
                <MenuItem value="CERTIFICATE_OF_AIRWORTHINESS">Certificate of Airworthiness</MenuItem>
                <MenuItem value="INSURANCE">Insurance</MenuItem>
                <MenuItem value="TYPE_CERTIFICATE">Type Certificate</MenuItem>
                <MenuItem value="OPERATOR_PERMIT">Operator Permit</MenuItem>
                <MenuItem value="IMPORT_DOCUMENTS">Import Documents</MenuItem>
                <MenuItem value="MODIFICATIONS">Modifications</MenuItem>
                <MenuItem value="OTHER">Other</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Document Sub-Type (Optional)"
                value={documentForm.documentSubType}
                onChange={(e) =>
                  setDocumentForm({ ...documentForm, documentSubType: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Description (Optional)"
                value={documentForm.description}
                onChange={(e) =>
                  setDocumentForm({ ...documentForm, description: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                component="label"
                fullWidth
                startIcon={<Upload />}
              >
                {documentForm.file ? documentForm.file.name : 'Select File'}
                <input
                  type="file"
                  hidden
                  onChange={(e) =>
                    setDocumentForm({
                      ...documentForm,
                      file: e.target.files && e.target.files[0] ? e.target.files[0] : null
                    })
                  }
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.mp4,.mov,.txt"
                />
              </Button>
              {documentUploading && (
                <Box sx={{ mt: 2 }}>
                  <LinearProgress variant="determinate" value={documentUploadProgress} />
                  <Typography variant="caption" sx={{ mt: 1 }}>
                    Uploading... {documentUploadProgress}%
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button
          onClick={onUpload}
          variant="contained"
          disabled={documentUploading || !documentForm.file || !documentForm.documentType}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentManagementDialog;

